import { ListItemButton, Stack } from "@mui/material";
import Text from "src/components/Displays/Text";
import { ChevronRight2 } from "src/assets";

interface EvseListItemProps {
  itemText: string;
  handleItemClick: () => {};
}

const EvseListItem = ({ itemText, handleItemClick }: EvseListItemProps) => {
  return (
    <>
      <ListItemButton onClick={handleItemClick}>
        <Stack
          sx={{
            justifyContent: "space-between",
            flexDirection: "row",
            alignItems: "center",
            width: "100%",
            py: 2,
          }}
        >
          <Text
            text={itemText}
            sx={(theme) => ({
              fontSize: "14px",
              fontWeight: "400",
              lineHeight: "20px",
              fontFamily: "Inter",
              color: theme.palette.black[50],
            })}
          />
          <Stack alignItems={"end"}>
            <ChevronRight2 />
          </Stack>
        </Stack>
      </ListItemButton>
    </>
  );
};

export default EvseListItem;
